<template>
    <div class="box">
        <div class="v_header flexCenter" ref="getheight1">
            <span class="headline">产品管理</span>
            <el-button class="input_button" size="mini" @click="getAdd('add','')">新增</el-button>
        </div>
        <el-table :data="message" :max-height="height+'px'" style="width: 100%">
            <el-table-column label="序号" width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    <span >{{ scope.$index+=1 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="product_number" label="产品编号" width="180" :render-header="renderPrice"> </el-table-column>
            <el-table-column label=" 产品名称" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.product_name" placement="bottom">
                        <span class="v_tips">{{ scope.row.product_name }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="getAdd('edit', scope)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="getDel(scope)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
        <el-dialog :title="row.id ? '修改产品' : '新增产品'" :visible.sync="resetDialogVisible" width="648px" top="15vh" class="v_dol">
            <el-form :model="row">
                <el-form-item label="产品编号">
                    <el-input class="el_input" v-model="row.product_number" size="mini" clearable placeholder="输入产品编号"></el-input>
                </el-form-item>
                <el-form-item label="产品名称">
                    <el-input class="el_input" v-model="row.product_name" size="mini" clearable placeholder="输入产品名称"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <div class="v_buttons" @click="resetDialogTrue">确 定</div>
            </div>
        </el-dialog>
        <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title">{{ msg }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'staff',
    data() {
        return {
            notificationns:false,
            msg:'',
            page: {
                num: 10,
                page: 1,
                total: 0
            },
            message: [],
            password: '',
            resetDialogVisible: false,
            row: {},
            index: -1,
            height:'',
        };
    },

    mounted() {
      
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height = this.screenHeight - this.$refs.getheight1.offsetHeight - 85-24-40;
        this.getMessage(); //获取列表
    },
    methods: {
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
        getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num
            };
            that.$get('/backapi/product', obj).then(function (res) {
                if (res.count) {
                    that.page.total = res.count;
                    that.message = res.data;
                } else {
                    that.page.total = 0;
                    that.message = [];
                }
            });
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
        //添加 编辑
        getAdd(type, e) {
            if (type == 'add') {
                this.resetDialog()
            } else if (type == 'edit') {
                this.row = JSON.parse(JSON.stringify(e.row));
                this.index = e.$index;
            }
            this.resetDialogVisible = true;
        },
        resetDialog() {
            this.row = {};
            this.index = -1;
            this.resetDialogVisible = false;
        },
        resetDialogTrue() {
            let that = this;
            if (!that.row.product_name) {
                that.$message({
                    type: 'warning',
                    message: '请输入产品名称'
                });
                return;
            }
            if (!that.row.product_number ) {
                that.$message({
                    type: 'warning',
                    message: '请输入产品编号'
                });
                return;
            }
            let obj = {
                product_name: that.row.product_name,
                product_number: that.row.product_number
            };
            if (that.row.id) {
                (obj.id = that.row.id),
                    that.$put('/backapi/product', obj).then(function (res) {
                        that.message[that.index].product_name = that.row.product_name;
                        that.message[that.index].product_number = that.row.product_number;
                        // that.$message({
                        //     type: 'success',
                        //     message: '修改成功'
                        // });
                        that.msg = '修改成功';
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                        that.resetDialog();
                    });
            } else {
                that.$post('/backapi/product', obj).then(function (res) {
                    // that.$message({
                    //     type: 'success',
                    //     message: '添加成功'
                    // });
                    that.msg = '添加成功';
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                    that.getMessage(); //获取列表
                    that.resetDialog();
                });
            }
        },
        // 删除
        getDel(e) {
            let that = this;
            that.$confirm('此操作将删除该产品, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.$del('/backapi/product', { id: e.row.id }).then(function (res) {
                        that.message.splice(e.$index, 1);
                        // that.$message({
                        //     type: 'success',
                        //     message: '删除成功'
                        // });
                        that.msg = '删除成功';
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                        that.resetDialog();
                    });
                })
                .catch(() => {
                    // that.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                    // that.msg = '已取消删除';
                    //     that.notificationns = true;
                    //     setTimeout(() => {
                    //         that.notificationns = false;
                    //     }, 3000);
                });
        },
        // 重置密码
        getReset(e) {
            this.resetDialogVisible = true;
        },

        // 取消操作
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.showAdd = false;
        },
        // 保存
        submitForm(formName) {
            let that = this;
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {};
                    // that.$post('/backapi/system_template', obj).then(function (res) {
                    //     if (res.code == 200) {
                    //         that.$message({
                    //             message: '添加成功',
                    //             type: 'success'
                    //         });
                    //         that.showAdd = false;
                    //         that.getMessage();
                    //     } else {
                    //         that.$message({
                    //             message: res.msg,
                    //             type: 'error'
                    //         });
                    //     }
                    // });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
/deep/.el-table .el-table__cell {
    border: none;
}

/deep/.el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.el-form-item__label {
    font-family: 'PingFang SC';
    font-weight: 400;
    font-size: 14px;
    color: #21272a;
}
.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 129px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

/deep/ .v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}

/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
.v_header {
    justify-content: space-between;
    margin-bottom: 24px;
}
/deep/.el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/.el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}

.demo-ruleForm {
    margin-left: 20px;
}
.mt15 {
    margin-top: 15px;
}
.mr10 {
    margin-right: 10px;
}
.size {
    font-size: 18px;
    margin-right: 5px;
}
</style>
